import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navigation from "./navigation";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./footer";
import { Editor, EditorState, convertFromRaw } from "draft-js";
import "./EventDetail.css";
import "../static/style.css";
import "../static/responsive.css";
import "../static/admin.css";
import "../static/common.css";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function EventDetails() {
  var { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());

  useEffect(() => {
    // fetch(`${API_URL}/api/events/11/${id}/`)
    // id = new URLSearchParams(window.location.search).get("id");
    fetch(`${API_URL}/api/events/${id}/`)
      .then(res => res.ok ? res.json() : Promise.reject("Not found"))
      .then(data => {
        setEvent(data);
        if (data.body) {
          try {
            setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(data.body))));
            console.log("Editor state set successfully", JSON.parse(data.body));
          } catch {
            setEditorState(EditorState.createEmpty());
          }
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Event not found");
        setLoading(false);
      });
  }, [id]);

  // Load Instagram embed script when Instagram videos are present
  useEffect(() => {
    if (event && event.videos && event.videos.some(video => video.is_instagram)) {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      } else {
        const script = document.createElement('script');
        script.async = true;
        script.src = '//www.instagram.com/embed.js';
        document.body.appendChild(script);
      }
    }
  }, [event]);

  // Date formatting function
  const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!event) return null;

  return (
    <div className="">
        <div style={{background: "black"}} > 
                <div className="fixed top-0 left-0 right-0 z-50">
  <Navigation />
</div>
        </div>
      <div className="hero-section2">
        <div className="page-title">Event Details</div>
      </div>
      <div className="max-width">
        <div className="section-margin-half"></div>

    
        <Link to="/events/" className="link-btn"> <i className="bi-chevron-left"></i> Go Back</Link>

        <div className="event-detail-containera">
          <div className="event-detail-header">
            <h2 className="event-title">{event.name}</h2>
            {event.status && (
              <span className={`event-status-badge-pending event-status-${event.status.toLowerCase()}`}>{event.status}</span>
            )}
          </div>

          {event.thumbnail && <img src={event.thumbnail} alt="thumbnail" className="event-detail-thumbnail" />}

          <div className="event-detail-meta vertical align-start">
            <span><b>Starts At :</b> {formatDateTime(event.start_date)}</span>
            {event.end_date && <span> <b>Ends At :</b>  {formatDateTime(event.end_date)}</span>}
            {/* <span className="event-category">{event.category}</span> */}
          </div>

          <h3>Events Summary</h3>
          <div className="event-detail-bodya">
            <Editor editorState={editorState} readOnly={true} />
          </div>


          <div className="event-detail-images">
            {event.images && event.images.map(img => (
              <img key={img.id} src={img.image} alt="event" className="event-detail-image" />
            ))}
          </div>

          {/* Video Section */}
          {event.videos && event.videos.length > 0 && (
            <div className="event-detail-videos">
              <h3>Videos</h3>
              <div className="videos-container">
                {event.videos.map((video, index) => (
                  <div key={video.id || index} className="video-embed-container">
                    {video.is_youtube && (
                      <iframe
                        src={video.complete_embed_url}
                        title={`YouTube video ${index + 1}`}
                        frameBorder="0"
                        height="100%"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="video-iframe"
                      ></iframe>
                    )}
                    
                    {video.is_instagram && (
                      <blockquote 
                        className="instagram-media" 
                        data-instgrm-permalink={video.url}
                        data-instgrm-version="14"
                        style={{
                          background: '#FFF',
                          border: '0',
                          borderRadius: '3px',
                          boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
                          margin: '1px',
                          maxWidth: '540px',
                          minWidth: '326px',
                          padding: '0',
                          width: '99.375%'
                        }}
                      >
                        <div style={{ padding: '16px' }}>
                          <a href={video.url} target="_blank" rel="noopener noreferrer">
                            View this post on Instagram
                          </a>
                        </div>
                      </blockquote>
                    )}
                    
                    {video.is_facebook && (
                      <iframe
                        src={video.complete_embed_url}
                        title={`Facebook video ${index + 1}`}
                        width="500"
                        height="100%"
                        style={{ border: 'none', overflow: 'hidden' }}
                        scrolling="no"
                        frameBorder="0"
                        allowFullScreen
                        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                        className="video-iframe"
                      ></iframe>
                    )}
                    
                    {!video.is_youtube && !video.is_instagram && !video.is_facebook && (
                      <div className="unsupported-video">
                        <p>Unsupported video platform</p>
                        <a href={video.url} target="_blank" rel="noopener noreferrer">
                          View Video
                        </a>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}


        </div>
        <div className="section-margin"></div>
      </div>
      
      {/* Video Embed Styles */}
      <style jsx>{`
        .event-detail-videos {
          margin-top: 30px;
        }
        
        .videos-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: 20px;
          margin-top: 20px;
        }
        
        .video-embed-container {
          width: 100%;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        
        .video-iframe {
          width: 100%;
          height: 315px;
          border: none;
          border-radius: 8px;
        }
        
        .instagram-media {
          margin: 0 auto !important;
        }
        
        .unsupported-video {
          padding: 20px;
          text-align: center;
          background: #f5f5f5;
          border-radius: 8px;
        }
        
        .unsupported-video a {
          color: #007bff;
          text-decoration: none;
        }
        
        .unsupported-video a:hover {
          text-decoration: underline;
        }
        
        @media (max-width: 768px) {
          .videos-container {
            grid-template-columns: 1fr;
            gap: 15px;
          }
          
          .video-iframe {
            height: 250px;
          }
        }
      `}</style>
      
      <Footer />
    </div>
  );
}

export default EventDetails;
